import { useState } from 'react';

export function useDisclose(initState: boolean = false) {
	const [isOpen, setIsOpen] = useState(initState);
	const onOpen = () => {
		setIsOpen(true);
	};
	const onClose = () => {
		setIsOpen(false);
	};
	const onToggle = () => {
		setIsOpen(prev => !prev);
	};
	return {
		isOpen,
		onOpen,
		onClose,
		onToggle,
	};
}
